import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { AdminApp } from "./AdminApp";
import { App } from "./App";
import "./styles.css";
import "./design-refinements.css";
import "./notification-settings.css";
import "./privacy.css";
import "./photo-management.css";
import "./reference-parity.css";
import "./interaction-layout.css";
import { initializeTheme } from "./theme";

initializeTheme();

const root = document.getElementById("root");
if (!root) throw new Error("app_root_missing");

const isAdminPath = window.location.pathname === "/admin" || window.location.pathname.startsWith("/admin/");

createRoot(root).render(<StrictMode>{isAdminPath ? <AdminApp /> : <App />}</StrictMode>);
